export const NAVIGATION = {
  GO_BACK: -1,
}
